import { Box, Typography } from "@mui/material";
import { ReactComponent as PointMessageDarkSVG } from 'images/chat/point-message-dark.svg';
import { ReactComponent as PointMessageSVG } from 'images/chat/point-message.svg';
import { AppTheme } from "theme";
import { IMessage } from "../type";

interface IProps {
  message: IMessage;
}

export default function PointMessage(props: IProps) {
  const {
    message
  } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box sx={{
        width: 260,
        height: 101,
        mx: -1,
        mt: -0.5,
        borderRadius: 2,
        overflow: "hidden",
      }}>
        {AppTheme.theme === 'dark' ? (
          <PointMessageDarkSVG
            style={{
              width: 260,
              height: 101,
            }}
          />
        ) : (
          <PointMessageSVG
            style={{
              width: 260,
              height: 101,
            }}
          />
        )}
      </Box>
      <Typography
        sx={{
          whiteSpace: "pre-wrap",
        }}
      >{message.message}</Typography>
    </Box>
  )
}